import { apiClient } from '../client'

export interface ConfigPresetSummary {
  id: string
  name: string
  description: string | null
  node_type: string
  node_type_name: string
  icon_name: string | null     // NEW — Lucide icon name; backend persistence pending
  is_valid: boolean
  is_system: boolean
  organization: string | null
  created_at: string
  last_update: string
}

export interface ConfigPresetDetail extends ConfigPresetSummary {
  config: Record<string, unknown>
}

export interface CreateConfigPresetPayload {
  name: string
  description?: string
  node_type: string
  icon_name?: string           // NEW — sent under key `icon_name`
  config: Record<string, unknown>
}

export interface UpdateConfigPresetPayload {
  name?: string
  description?: string
  icon_name?: string           // NEW
  config?: Record<string, unknown>
}

// Adapter: orch ConfigPresetResponse → FE legacy shape.
// Orch uses `component_id`, `organization_id`, `updated_at`. The FE keeps
// `node_type`, `organization`, `last_update`. `node_type_name` has no orch
// equivalent — left empty (cosmetic only; consumers handle missing labels).
const orchPresetToFe = (p: any): ConfigPresetDetail => ({
  id: p.id,
  name: p.name,
  description: p.description ?? null,
  node_type: p.component_id ?? p.node_type ?? '',
  node_type_name: p.component_name ?? p.node_type_name ?? '',
  icon_name: p.icon_name ?? null,        // NEW
  is_valid: p.is_valid ?? true,
  is_system: !!p.is_system,
  organization: p.organization_id ?? p.organization ?? null,
  created_at: p.created_at,
  last_update: p.updated_at ?? p.last_update,
  config: p.config ?? {},
})

const feCreateToOrch = (p: CreateConfigPresetPayload) => ({
  name: p.name,
  description: p.description,
  component_id: p.node_type,
  icon_name: p.icon_name,                // NEW
  config: p.config,
})

export const configPresetsApi = {
  /** List presets, optionally filtered by component (legacy `nodeTypeId`). */
  getList: async (nodeTypeId?: string): Promise<ConfigPresetSummary[]> => {
    console.log("aaa", nodeTypeId)
    const url = nodeTypeId
      ? `/workflow/config-presets/?component_id=${encodeURIComponent(nodeTypeId)}`
      : '/workflow/config-presets/'
    const { data } = await apiClient.get(url)
    const items = Array.isArray(data) ? data : data?.data ?? []
    return items.map(orchPresetToFe)
  },

  getById: async (presetId: string): Promise<ConfigPresetDetail> => {
    const { data } = await apiClient.get(`/workflow/config-presets/${presetId}/`)
    return orchPresetToFe(data)
  },

  create: async (payload: CreateConfigPresetPayload): Promise<ConfigPresetDetail> => {
    const { data } = await apiClient.post('/workflow/config-presets/', feCreateToOrch(payload))
    return orchPresetToFe(data)
  },

  update: async (
    presetId: string,
    payload: UpdateConfigPresetPayload,
  ): Promise<ConfigPresetDetail> => {
    const { data } = await apiClient.patch(`/workflow/config-presets/${presetId}/`, payload)
    return orchPresetToFe(data)
  },

  delete: async (presetId: string): Promise<void> => {
    await apiClient.delete(`/workflow/config-presets/${presetId}/`)
  },
}
